export default __webpack_public_path__ + "static/media/burger.17b8011e.png";